import styled from "styled-components";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const MedicamentoStyles = {
  autFormButtonWidth: "auto",
  autFormButtonHeight: "50px",
};

export const MedicamentoFormButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MedicamentoFormButtonsLeft = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MedicamentoFormButtonsRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

//FirmaModal

export const FirmaModalContainer = styled.div`
  padding: 50px;
`;

export const FirmaModalContent = styled.div`
  align-items: center;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FirmaModalButtonContainer = styled.div`
  flex: 1;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const FirmaModalButtonsLeft = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const FirmaModalButtonsRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;
